import axios from 'axios';
import { AppNS } from 'app';

import { API_URL } from 'app/core/config';


const INVITE_URL = 'invitations.json';

export function apiGetInvitations(): Promise<[]> {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${INVITE_URL}`)
      .then(({ data }) => {
        if (data.results) {
          resolve(data.results);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}


export function inviteUser(reqData: AppNS.Params): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${INVITE_URL}`, reqData)
      .then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(data);

          // reject('Invalid response data');
        }
      })
      .catch(
        (error) => {
          reject(error.response.data)
        }
      );
  });
}

export function editPermissions(reqData: AppNS.Params): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${INVITE_URL}`, reqData)
      .then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(
        (error) => {
          reject(error.response.data)
        }
      );
  });
}

export function cancelInvitation(reqData: AppNS.Params): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/invitations/change-state.json`, reqData)
      .then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          reject('Invalid response data');
        }
      })
      .catch((error) => {
        return reject(error.response.data.errors);
      });
  });
}


export function apiChangeInvitationState(id: string, state: string): Promise<string> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/invitations/change-state.json`, {
        id,
        properties: {
          state: state
        }
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.id);
        } else {
          if (data.errors) {
            reject(data.errors);
          }
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
